// extracted by mini-css-extract-plugin
export default {"divider":"hExb3Ck1zxAYSsEYDx1vOA=="};